// import React from "react";
// import Markup from "./jsx";

// import "./css/style.css";
// // import { withResizeDetector } from "react-resize-detector";

// const App = ({ width }) => {
  
//   return (  
// 		<Markup />  
//   );
// };

// // export default withResizeDetector(App);
// export default App;

import React from "react";
import Markup from "./jsx";
import "./css/style.css";
import { useResizeDetector } from "react-resize-detector";

const App = () => {
  const { width, height, ref } = useResizeDetector();

  console.log(width);

  return (
    <div ref={ref}>
      <Markup />
    </div>
  );
};

export default App;